<ng-container [ngSwitch]="item.uiType">
  <button *ngSwitchCase="'icon'" class="centered-vert styleless-btn w-full" (click)="invokeAction()">
    <span class="mr-5px" [ngClass]="getIconClass()"></span>
    <span>{{ item.key | localize }}</span>
  </button>

  <button *ngSwitchCase="'uiIcon'" class="centered-vert styleless-btn w-full" (click)="invokeAction()">
    <ui-icon class="mr-5px" [uiType]="getIconType()" [uiTheme]="getIconTheme()"></ui-icon>
    <span>{{ item.key | localize }}</span>
  </button>

  <button *ngSwitchCase="'toggle'" class="centered-vert justify-cont-sb styleless-btn w-full">
    <span>{{ item.key | localize }}</span>
    <ui-toggle [value]="getToggleValue()" [uiType]="'toggle-text'" (onToggled)="invokeAction()"></ui-toggle>
  </button>

  <button *ngSwitchDefault class="styleless-btn" (click)="invokeAction()">
    <span>{{ item.key | localize }}</span>
  </button>
</ng-container>
